/**
 * @file Lightbox.
 */

import GLightbox from 'glightbox';

/**
 * Lightbox components.
 */
const vLightbox = () => {
	const triggers = document.querySelectorAll('.v-lightbox-trigger');

	if (!triggers.length) {
		return;
	}

	GLightbox({
		loop: true,
		selector: '.v-lightbox-trigger',
		videosWidth: '1280px',
		draggable: false,
	});

	document.addEventListener('facetwp-loaded', () => {
		GLightbox({
			loop: true,
			selector: '.facetwp-template .v-lightbox-trigger',
			videosWidth: '1280px',
			draggable: false,
		});
	});
};

export default vLightbox;
